import store from "../store/index";
import enumApi from "@/api/enum/enumApi";

const utils = {
  // 判断行政区级别
  judgeDivision(divisionCode) {
    if (divisionCode) {
      if (divisionCode.substring(divisionCode.length - 3) != "000") {
        return "village";
      } else if (
        divisionCode.substring(divisionCode.length - 3) == "000" &&
        divisionCode.substring(divisionCode.length - 6) != "000000"
      ) {
        return "town";
      } else if (
        divisionCode.substring(6, 12) == "000000" &&
        divisionCode.substring(4, 6) != "00"
      ) {
        return "county";
      } else if (
        divisionCode.substring(4, 12) == "00000000" &&
        divisionCode.substring(2, 4) != "00"
      ) {
        return "city";
      } else if (divisionCode == "450000000000") {
        return "province";
      }
    } else {
      return null;
    }
  },
  // 判断数字类型的值是否为空，hasOwnProperty可以保证为0的值也可以正常显示
  judgeNumNull(obj, key) {
    // eslint-disable-next-line no-prototype-builtins
    return obj.hasOwnProperty(key) ? obj[key] : "";
  },
  // 判断合法数字
  checkNumber(number) {
    if (number == 0) return "0";
    if (!number) return "0";
    if (typeof number == "number") return number.toLocaleString();
    return number;
  },
  IdCodeValid_X(code, judgeId) {
    //身份证号合法性验证
    //支持15位和18位身份证号和20位残疾证
    //支持地址编码、出生日期、校验位验证
    var city = {
      11: "北京",
      12: "天津",
      13: "河北",
      14: "山西",
      15: "内蒙古",
      21: "辽宁",
      22: "吉林",
      23: "黑龙江",
      31: "上海",
      32: "江苏",
      33: "浙江",
      34: "安徽",
      35: "福建",
      36: "江西",
      37: "山东",
      41: "河南",
      42: "湖北 ",
      43: "湖南",
      44: "广东",
      45: "广西",
      46: "海南",
      50: "重庆",
      51: "四川",
      52: "贵州",
      53: "云南",
      54: "西藏 ",
      61: "陕西",
      62: "甘肃",
      63: "青海",
      64: "宁夏",
      65: "新疆",
      71: "台湾",
      81: "香港",
      82: "澳门",
      91: "国外 ",
    };
    var row = {
      pass: true,
      msg: "验证成功",
    };
    if (
      ["isNormalID", "isDisabilityID"].indexOf(judgeId) == -1 &&
      (!code ||
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[X]|(\d|[X])\d{2}|(\d|[X])\d{2}[B]\d)$/.test(
          code
        ))
    ) {
      row = {
        pass: false,
        msg: "证件号格式错误",
      };
    } else if (
      judgeId == "isNormalID" &&
      (!code ||
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[X])$/.test(
          code
        ))
    ) {
      row = {
        pass: false,
        msg: "证件号格式错误",
      };
    } else if (
      judgeId == "isDisabilityID" &&
      (!code ||
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}((\d|[X])\d{2}|(\d|[X])\d{2}[B]\d)$/.test(
          code
        ))
    ) {
      row = {
        pass: false,
        msg: "残疾人证件号格式错误",
      };
    } else if (!city[code.substr(0, 2)]) {
      row = {
        pass: false,
        msg: "证件号地址编码错误",
      };
    } else {
      //18位身份证需要验证最后一位校验位
      if (code.length == 18) {
        code = code.split("");
        //∑(ai×Wi)(mod 11)
        //加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        //校验位
        var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
        var sum = 0;
        var ai = 0;
        var wi = 0;
        for (var i = 0; i < 17; i++) {
          ai = code[i];
          wi = factor[i];
          sum += ai * wi;
        }
        // toUpperCase() 方法将字符串小写字符转换为大写
        if (parity[sum % 11] != code[17].toUpperCase()) {
          row = {
            pass: false,
            msg: "证件号校验位错误",
          };
        }
      }
    }
    return row;
  },
  //精度计算
  fixedFloat(a, b, sign) {
    function padding0(p) {
      var z = "";
      while (p--) {
        z += "0";
      }
      return z;
    }

    function handle(x) {
      var y = String(x);
      var p = y.lastIndexOf(".");
      if (p === -1) {
        return [y, 0];
      } else {
        return [y.replace(".", ""), y.length - p - 1];
      }
    }
    // v 操作数1, w 操作数2, s 操作符, t 精度
    function operate(v, w, s, t) {
      switch (s) {
        case "+":
          return (v + w) / t;
        case "-":
          return (v - w) / t;
        case "*":
          return (v * w) / (t * t);
        case "/":
          return v / w;
      }
    }

    var c = handle(a);
    var d = handle(b);
    var k = 0;

    if (c[1] === 0 && d[1] === 0) {
      return operate(+c[0], +d[0], sign, 1);
    } else {
      k = Math.pow(10, Math.max(c[1], d[1]));
      if (c[1] !== d[1]) {
        if (c[1] > d[1]) {
          d[0] += padding0(c[1] - d[1]);
        } else {
          c[0] += padding0(d[1] - c[1]);
        }
      }
      return operate(+c[0], +d[0], sign, k);
    }
  },
  // 手机号校验
  phoneValid(val) {
    var row = {
      pass: true,
      msg: "验证成功",
    };

    let myreg = /^[1][1-9][0-9]{9}$/;
    if (!myreg.test(val)) {
      row = {
        pass: false,
        msg: "联系电话格式错误",
      };
    }
    return row;
  },

  formatDate(time, type, num) {
    if (time) {
      var date = "";
      if (typeof time == "string") {
        time = time.split(/\D+/);
        if (time.length == 3) {
          date = new Date(time[0], time[1] - 1, time[2]);
        } else {
          date = new Date(
            time[0],
            time[1] - 1,
            time[2],
            time[3],
            time[4],
            time[5]
          );
        }
      } else {
        date = new Date(time);
      }
      if (num != undefined && num != null && typeof num === "number") {
        date = new Date(new Date(time).getTime() + num * 60 * 60 * 24 * 1000); // 时间戳以毫秒为单位,也可用其他日期格式
      }
      const yy = date.getFullYear(); // 年
      const mm = date.getMonth() + 1; // 月
      const dd = date.getDate(); // 日
      const hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); // 小时
      const mf =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(); // 分钟
      const ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds(); // 秒
      if (type == "DT1") {
        return yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss; // yyyy-mm-dd hh:mf:ss
      } else if (type == "DT2") {
        return yy + "-" + mm + "-" + dd; // yyyy-mm-dd
      } else if (type == "DT3") {
        return yy + "/" + mm + "/" + dd + " " + hh + ":" + mf + ":" + ss; // yyyy/mm/dd hh:mf:ss
      } else if (type == "DT4") {
        return yy + "-" + mm + "-" + dd; // yyyy/mm/dd
      } else if (type == "DT5") {
        return date.getTime(); // 时间戳 秒数
      } else if (type == "DT6") {
        return (
          yy + "年" + mm + "月" + dd + "日 " + hh + "时" + mf + "分" + ss + "秒"
        ); // yyyy年mm月dd日 hh时mf分ss秒
      } else if (type == "DT7") {
        return yy + "年" + mm + "月" + dd + "日"; // yyyy年mm月dd日
      } else if (type == "DT8") {
        return mm + "/" + dd; // 月-日
      } else if (type == "DT9") {
        return mm + "/" + dd; // 月/日
      } else if (type == "DT10") {
        return yy + "" + mm + "" + dd + "" + hh + "" + mf + "" + ss; // 月/日
      }
    }
  },
  //删除对象中的空属性
  filterEmpty(obj) {
    const cleanOjb = {};
    for (const key in obj) {
      if (!["", null, undefined].includes(obj[key])) {
        cleanOjb[key] = obj[key];
      }
    }
    return cleanOjb;
  },
  // 表格城市返回删除多余 >
  cityName(val) {
    let str = `${val.cityName ? val.cityName : ""}>${val.countyName ? val.countyName : ""
      }>${val.townName ? val.townName : ""}>${val.villageName ? val.villageName : ""
      }`;
    while (str.endsWith(">")) {
      str = str.substring(0, str.length - 1);
    }
    return str;
  },
  /**
   * 玉州各村中心点数据封装
   * @param division
   */
  mapCenterPoint(division) {
    let center = [];
    switch (division) {
      //名山街道
      case "450902005000":
        center = [110.165108, 22.67073];
        return center;
      //名山街道-二泉村
      case "450902005001":
        center = [110.1599, 22.6804];
        return center;
      //名山街道-绿杨社区
      case "450902005002":
        center = [110.1665, 22.6637];
        return center;
      //名山街道-名山社区
      case "450902005003":
        center = [110.1556, 22.6526];
        return center;
      //名山街道-太阳村
      case "450902005004":
        center = [110.1574, 22.6698];
        return center;
      //名山街道-腾杨村
      case "450902005005":
        center = [110.1814, 22.6999];
        return center;
      //名山街道-旺瑶社区
      case "450902005006":
        center = [110.1764, 22.6354];
        return center;
      //名山街道-五里桥社区
      case "450902005007":
        center = [110.165108, 22.67073];
        return center;
      //名山街道-朱砂村
      case "450902005008":
        center = [110.1615, 22.6939];
        return center;
      //大塘镇
      case "450902003000":
        center = [110.117165, 22.772698];
        return center;
      //大塘镇-大双村
      case "450902003001":
        center = [110.1248, 22.8028];
        return center;
      //大塘镇-大塘村
      case "450902003002":
        center = [110.1343, 22.7311];
        return center;
      //大塘镇-三和村
      case "450902003003":
        center = [110.1115, 22.7637];
        return center;
      //大塘镇-苏烟村
      case "450902003004":
        center = [110.1279, 22.7752];
        return center;
      //大塘镇-阳山村
      case "450902003005":
        center = [110.1189, 22.7464];
        return center;
      //茂林镇
      // case '450902004000':
      // center = [110.253254, 22.663708];
      // return center;
      //茂林镇-陂石社区
      case "450902004001":
        center = [110.277, 22.692];
        return center;
      //茂林镇-陂耀社区
      case "450902004002":
        center = [110.2609, 22.6821];
        return center;
      //茂林镇-长望社区
      case "450902004003":
        center = [110.2096, 22.6384];
        return center;
      //茂林镇-车垌社区
      case "450902004004":
        center = [110.241, 22.6325];
        return center;
      //茂林镇-大芦社区
      case "450902004005":
        center = [110.2055, 22.678];
        return center;
      //茂林镇-大囊社区
      case "450902004006":
        center = [110.1961, 22.6267];
        return center;
      //茂林镇-和睦社区
      case "450902004007":
        center = [110.1814, 22.6759];
        return center;
      //茂林镇-金谷社区
      case "450902004008":
        center = [110.2263, 22.6536];
        return center;
      //茂林镇-鹿峰社区
      case "450902004009":
        center = [110.2702, 22.6594];
        return center;
      //茂林镇-鹿潘社区
      case "450902004010":
        center = [110.2792, 22.6298];
        return center;
      //茂林镇-鹿塘社区
      case "450902004011":
        center = [110.2898, 22.6441];
        return center;
      //茂林镇-茂林社区
      case "450902004012":
        center = [110.2398, 22.6778];
        return center;
      //茂林镇-泉东社区
      case "450902004013":
        center = [110.2272, 22.7033];
        return center;
      //茂林镇-泉塘社区
      case "450902004014":
        center = [110.2028, 22.6521];
        return center;
      //茂林镇-泉西社区
      case "450902004015":
        center = [110.2229, 22.6894];
        return center;
      //茂林镇-榕楼社区
      case "450902004016":
        center = [110.2039, 22.7056];
        return center;
      //茂林镇-沙井社区
      case "450902004017":
        center = [110.2663, 22.6387];
        return center;
      //茂林镇-山电社区
      case "450902004018":
        center = [110.2474, 22.6518];
        return center;
      //茂林镇-石棠社区
      case "450902004019":
        center = [110.1833, 22.6594];
        return center;
      //茂林镇-湘汉社区
      case "450902004020":
        center = [110.2265, 22.6243];
        return center;
      //茂林镇-新寨社区
      case "450902004021":
        center = [110.2917, 22.6735];
        return center;
      //仁东镇
      case "450902007000":
        center = [110.079394, 22.667855];
        return center;
      //仁东镇-良村
      case "450902007006":
        center = [110.04421, 22.72291];
        return center;
      //仁东镇-周村
      case "450902007013":
        center = [110.05461, 22.71211];
        return center;
      //仁东镇-石地村
      case "450902007009":
        center = [110.04714, 22.69399];
        return center;
      //仁东镇-沼心村
      case "450902007011":
        center = [110.07148, 22.70464];
        return center;
      //仁东镇-鹤林村
      case "450902007005":
        center = [110.07236, 22.68352];
        return center;
      //仁东镇-旺卢村
      case "450902007010":
        center = [110.11786, 22.6723];
        return center;
      //仁东镇-大鹏村
      case "450902007002":
        center = [110.0908, 22.67515];
        return center;
      //仁东镇-龚罗村
      case "450902007004":
        center = [110.06499, 22.65139];
        return center;
      //仁东镇-木根村
      case "450902007007":
        center = [110.06807, 22.62651];
        return center;
      //仁东镇-都甘村
      case "450902007003":
        center = [110.08155, 22.63697];
        return center;
      //仁东镇-鹏垌村
      case "450902007008":
        center = [110.09096, 22.64533];
        return center;
      //仁东镇-大路社区
      case "450902007001":
        center = [110.07156, 22.66341];
        return center;
      //仁东镇-中庞村
      case "450902007012":
        center = [110.0948, 22.65625];
        return center;
      //仁厚镇
      case "450902008000":
        center = [110.031136, 22.648285];
        return center;
      //仁厚镇-大卢村
      case "450902008001":
        center = [110.0055, 22.6449];
        return center;
      //仁厚镇-道良村
      case "450902008002":
        center = [110.0501, 22.6307];
        return center;
      //仁厚镇-荔枝村
      case "450902008003":
        center = [110.0288, 22.6426];
        return center;
      //仁厚镇-茂岑村
      case "450902008004":
        center = [110.0039, 22.6273];
        return center;
      //仁厚镇-仁厚村
      case "450902008005":
        center = [110.0493, 22.6408];
        return center;
      //仁厚镇-上罗村
      case "450902008006":
        center = [110.0411, 22.6718];
        return center;
      //仁厚镇-铁匠村
      case "450902008007":
        center = [110.0304, 22.6297];
        return center;
      //仁厚镇-下罗村
      case "450902008008":
        center = [110.0525, 22.6607];
        return center;
      //仁厚镇-新旺村
      case "450902008009":
        center = [110.0297, 22.6521];
        return center;
      //玉城街道
      case "450902009000":
        center = [110.146614, 22.633577];
        return center;
      //玉城街道-北辰社区
      case "450902009001":
        center = [110.1375, 22.632];
        return center;
      //玉城街道-大新社区
      case "450902009002":
        center = [110.1289, 22.6273];
        return center;
      //玉城街道-东成社区
      case "450902009003":
        center = [110.1481, 22.6312];
        return center;
      //玉城街道-东明社区
      case "450902009004":
        center = [110.1577, 22.6286];
        return center;
      //玉城街道-东岳社区
      case "450902009005":
        center = [110.1575, 22.639];
        return center;
      //玉城街道-垌口社区
      case "450902009006":
        center = [110.1378, 22.6267];
        return center;
      //玉城街道-南观社区
      case "450902009007":
        center = [110.1444, 22.6248];
        return center;
      //玉城街道-清湾江社区
      case "450902009008":
        center = [110.1378, 22.6462];
        return center;
      //玉城街道-胜利垌社区
      case "450902009009":
        center = [110.1655, 22.6367];
        return center;
      //玉城街道-西就社区
      case "450902009010":
        center = [110.1499, 22.6253];
        return center;
      //玉城街道-新民社区
      case "450902009011":
        center = [110.1369, 22.6195];
        return center;
      //玉城街道-州佩社区
      case "450902009012":
        center = [110.1432, 22.6377];
        return center;
      //南江街道
      case "450902006000":
        center = [110.160554, 22.592457];
        return center;
      //南江街道-常乐村
      case "450902006001":
        center = [110.1961, 22.6028];
        return center;
      //南江街道-分界村
      case "450902006002":
        center = [110.1601, 22.5524];
        return center;
      //南江街道-广恩村
      case "450902006003":
        center = [110.1028, 22.587];
        return center;
      //南江街道-合汉村
      case "450902006004":
        center = [110.2115, 22.6181];
        return center;
      //南江街道-岭塘村
      case "450902006006":
        center = [110.1752, 22.5846];
        return center;
      //南江街道-南江社区
      case "450902006007":
        center = [110.1572, 22.6032];
        return center;
      //南江街道-平志村
      case "450902006008":
        center = [110.1248, 22.5968];
        return center;
      //南江街道-坡塘村
      case "450902006009":
        center = [110.1181, 22.5768];
        return center;
      //南江街道-七一村
      case "450902006010":
        center = [110.1467, 22.5786];
        return center;
      //南江街道-新联村
      case "450902006011":
        center = [110.1352, 22.5899];
        return center;
      //南江街道-云良村
      case "450902006014":
        center = [110.2354, 22.6092];
        return center;
      //南江街道-镇忠社区
      case "450902006015":
        center = [110.174, 22.622];
        return center;
      //南江街道-竹美社区
      case "450902006016":
        center = [110.1422, 22.6077];
        return center;
      //城西街道
      case "450902002000":
        center = [110.102907, 22.6292];
        return center;
      //城西街道-江岸社区
      case "450902002001":
        center = [110.1311, 22.6454];
        return center;
      //城西街道-莲塘村
      case "450902002002":
        center = [110.1112, 22.6472];
        return center;
      //城西街道-林村
      case "450902002003":
        center = [110.1304, 22.6607];
        return center;
      //城西街道-庆丰社区
      case "450902002004":
        center = [110.1203, 22.6363];
        return center;
      //城西街道-五联村
      case "450902002005":
        center = [110.1003, 22.6039];
        return center;
      //城西街道-新定村
      case "450902002006":
        center = [110.1058, 22.6225];
        return center;
      //城西街道-新团社区
      case "450902002007":
        center = [110.1235, 22.6173];
        return center;
      //城西街道-永上村
      case "450902002008":
        center = [110.098, 22.6303];
        return center;
      //城西街道-玉豸村
      case "450902002009":
        center = [110.1139, 22.6098];
        return center;
      //城北街道
      case "450902001000":
        center = [110.114773, 22.711934];
        return center;
      //城北街道-陈旺村
      case "450902001001":
        center = [110.0878, 22.7472];
        return center;
      //城北街道-凤村
      case "450902001002":
        center = [110.1313, 22.6864];
        return center;
      //城北街道-高山村
      case "450902001003":
        center = [110.1456, 22.6915];
        return center;
      //城北街道-谷山村
      case "450902001004":
        center = [110.1427, 22.6682];
        return center;
      //城北街道-寒山村
      case "450902001005":
        center = [110.0912, 22.7346];
        return center;
      //城北街道-罗竹村
      case "450902001006":
        center = [110.0974, 22.7199];
        return center;
      //城北街道-睦马村
      case "450902001007":
        center = [110.1211, 22.7178];
        return center;
      //城北街道-排榜村
      case "450902001008":
        center = [110.1335, 22.7052];
        return center;
      //城北街道-潘岭村
      case "450902001009":
        center = [110.1425, 22.6791];
        return center;
      //城北街道-彭村
      case "450902001010":
        center = [110.1179, 22.7261];
        return center;
      //城北街道-平地社区
      case "450902001011":
        center = [110.1419, 22.6552];
        return center;
      //城北街道-西岸村
      case "450902001012":
        center = [110.0993, 22.7002];
        return center;
      //城北街道-钟周村
      case "450902001013":
        center = [110.1184, 22.6946];
        return center;
      //城北街道-周埠村
      case "450902001014":
        center = [110.15, 22.7058];
        return center;
      default:
        center = [110.114773, 22.711934];
        return center;
    }
  },
  // 获取菜单功能列表
  getPowerList(menuKey) {
    return new Promise((resolve, reject) => {
      let count = 0;
      const timer = setInterval(() => {
        console.log(store.state.permissionList);
        if (Object.keys(store.state.permissionList).length != 0) {
          clearInterval(timer);
          resolve(store.state.permissionList[menuKey] ?? []);
        } else {
          count++;
        }
        if (count > 20) {
          clearInterval(timer);
          reject("菜单请求超时");
        }
      }, 500);
    });
  },
  //权限控制
  handlePower(powerList, powerId, keyModel = "name") {
    //默认以name判断，keyModel传menuKey 则以menuKey判断
    if (!powerList || !powerId) {
      return false;
    }
    return powerList.some((item) => item[keyModel] == powerId);
  },
  // //权限控制
  // async handlePower(menuKey, powerId, keyModel = "name") {
  //   //默认以name判断，keyModel传menuKey 则以menuKey判断
  //   if (!menuKey || !powerId) {
  //     return false;
  //   }
  //   const powerList = await this.getPowerList(menuKey);
  //   return powerList.some((item) => item[keyModel] == powerId);
  // },
  // 获取系统参数
  async getSysEnum(val) {
    return new Promise((resolve, reject) => {
      enumApi.dictionaryList(val).then((res) => {
        if (res.data.code == "00") {
          let resData = res.data.rows;
          resolve(resData);
        }
      });
    });
  },
  // 异步等待天地图
  getMapObjectAsync() {
    return new Promise((resolve, reject) => {
      //判断十秒内是否可以获取window.T对象
      let count = 0;
      let timer = setInterval(() => {
        if (window.T) {
          clearInterval(timer);
          resolve(window.T);
        } else {
          count++;
          if (count >= 20) {
            clearInterval(timer);
            reject("获取天地图对象失败");
          }
        }
      }, 1000);
    });
  },
};

export default utils;
